/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 3
// module chunks = 1